import { FrontendUserSchema } from '@buyerflo/core/schemas/userMembership'
import Button from 'components/button'
import { Dialog, SizableText, XStack } from 'tamagui'
import { useTRPC } from 'utils/trpc'
import { useMutation } from '@tanstack/react-query'
import { useUsersApi } from 'apiProviders'
import Modal, { dontCloseOnBackgroundClick } from 'components/modal'
import { useNavigate } from 'react-router'

interface RemoveUserModalProps {
    open: boolean
    user?: FrontendUserSchema
    onClose: () => void
}

export default ({ open, onClose, user }: RemoveUserModalProps) => {
    const trpc = useTRPC()
    const usersApi = useUsersApi()
    const navigate = useNavigate()
    const removeUserMutation = useMutation(trpc.users.removeUser.mutationOptions())

    return (
        <Modal
            open={open}
            onOpenChange={(open) => { if (!open) onClose() }}
        >
            <Dialog.Title>Remove User</Dialog.Title>
            <SizableText>
                Are you sure you wish to remove {user?.firstName} {user?.lastName}?
            </SizableText>
            <XStack gap="$2" flexDirection="row-reverse">
                <Button
                    theme="red"
                    onPress={async () => {
                        await removeUserMutation.mutateAsync({ userId: user!.userId })
                        await usersApi.refresh()
                        navigate('..')
                        onClose()
                    }}
                >
                    Remove
                </Button>
                <Button
                    onPress={onClose}
                    variant="outlined"
                >
                    Cancel
                </Button>
            </XStack>
        </Modal>
    )
}
